import React from 'react';
import moment from 'moment';
import { DatePicker } from 'components';
import { Calendar } from 'assets/icons';
import { DateRange } from '../hooks/use-date-range';

interface Props {
  range: DateRange;
  onChange: (range: DateRange) => void;
}

/**
 * Filtro de fecha compartido por todas las secciones de "Tendencias" --
 * un solo pill visual (no dos cajas separadas), inspirado en el selector
 * "Jan 1, 2025 - Feb 1, 2025" de la referencia compartida. No afecta a las
 * secciones de "Estado actual" -- ver nota en analytics.tsx.
 */
const DateRangeFilter = ({ range, onChange }: Props) => {
  return (
    <div className='date-range-filter'>
      <img className='calendar-pill-icon' src={Calendar} alt='' />
      <DatePicker
        value={moment(range.startDate).toDate()}
        maxDate={moment(range.endDate).toDate()}
        onChange={(date: Date) =>
          onChange({ ...range, startDate: moment(date).format('YYYY-MM-DD') })
        }
      />
      <span className='separator'>–</span>
      <DatePicker
        value={moment(range.endDate).toDate()}
        minDate={moment(range.startDate).toDate()}
        maxDate={moment().toDate()}
        onChange={(date: Date) =>
          onChange({ ...range, endDate: moment(date).format('YYYY-MM-DD') })
        }
      />
    </div>
  );
};

export default DateRangeFilter;
